import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Kanit\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"],\"variable\":\"--font-kanit\",\"preload\":true,\"fallback\":[\"system-ui\",\"sans-serif\"],\"adjustFontFallback\":false}],\"variableName\":\"kanit\"}");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Archivo\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"],\"variable\":\"--font-archivo\",\"preload\":true,\"fallback\":[\"system-ui\",\"sans-serif\"],\"adjustFontFallback\":false}],\"variableName\":\"archivo\"}");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/_styles/ds.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/services.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentProvider","FixedBottomContainer"] */ "/usr/app/src/components/layout/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/utils/BreadcrumbJsonLd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/utils/SPAPageViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcherProvider"] */ "/usr/app/src/contexts/LanguageSwitcherContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollAnchorProvider"] */ "/usr/app/src/contexts/ScrollAnchorContext.tsx");
